"use strict"; // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var _toConsumableArray = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
}); // This implements Data-Driven Guides (straight line guide).

var mark_1 = require("./mark");

var solver_1 = require("../../solver");

var Specification = require("../../specification");

var attrs_1 = require("../attrs");

var axis_1 = require("../plot_segments/axis");

var DataAxisClass =
/*#__PURE__*/
function (_mark_1$MarkClass) {
  _inherits(DataAxisClass, _mark_1$MarkClass);

  function DataAxisClass() {
    _classCallCheck(this, DataAxisClass);

    return _possibleConstructorReturn(this, _getPrototypeOf(DataAxisClass).apply(this, arguments));
  }

  _createClass(DataAxisClass, [{
    key: "getAttributeNames",
    value: function getAttributeNames(expr) {
      return ["anchorX".concat(expr.name), "anchorY".concat(expr.name)];
    }
  }, {
    key: "buildConstraints",
    value: function buildConstraints(solver, context) {
      if (context == null) {
        return;
      }

      var attrs = this.state.attributes;
      var props = this.object.properties;

      var _solver$attrs = solver.attrs(attrs, ["x1", "y1", "x2", "y2"]),
          _solver$attrs2 = _slicedToArray(_solver$attrs, 4),
          x1 = _solver$attrs2[0],
          y1 = _solver$attrs2[1],
          x2 = _solver$attrs2[2],
          y2 = _solver$attrs2[3];

      if (props.axis) {
        if (props.axis.type == "numerical") {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = props.dataExpressions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              var _this$getAttributeNam = this.getAttributeNames(item),
                  _this$getAttributeNam2 = _slicedToArray(_this$getAttributeNam, 2),
                  attrX = _this$getAttributeNam2[0],
                  attrY = _this$getAttributeNam2[1];

              var expr = context.getExpressionValue(item.expression, context.rowContext);
              var interp = axis_1.getNumericalInterpolate(props.axis);
              var t = interp(expr);

              if (attrs[attrX] == null) {
                attrs[attrX] = attrs.x1;
              }

              if (attrs[attrY] == null) {
                attrs[attrY] = attrs.y1;
              }

              solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[t, x2], [1 - t, x1]], [[1, solver.attr(attrs, attrX)]]);
              solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[t, y2], [1 - t, y1]], [[1, solver.attr(attrs, attrY)]]);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
      }
    } // Initialize the state of an element so that everything has a valid value

  }, {
    key: "initializeState",
    value: function initializeState() {
      var attrs = this.state.attributes;
      attrs.x1 = -10;
      attrs.y1 = -10;
      attrs.x2 = 10;
      attrs.y2 = 10;
    } // Get bounding rectangle given current state

  }, {
    key: "getHandles",
    value: function getHandles() {
      var attrs = this.state.attributes;
      return [{
        type: "point",
        x: attrs.x1,
        y: attrs.y1,
        actions: [{
          type: "attribute",
          source: "x",
          attribute: "x1"
        }, {
          type: "attribute",
          source: "y",
          attribute: "y1"
        }]
      }, {
        type: "point",
        x: attrs.x2,
        y: attrs.y2,
        actions: [{
          type: "attribute",
          source: "x",
          attribute: "x2"
        }, {
          type: "attribute",
          source: "y",
          attribute: "y2"
        }]
      }];
    }
  }, {
    key: "getGraphics",
    value: function getGraphics(cs, offset) {
      var glyphIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var attrs = this.state.attributes;
      var props = this.object.properties;

      switch (props.visibleOn) {
        case "all":
          break;

        case "last":
          {
            if (glyphIndex != this.getPlotSegmentClass().state.glyphs.length - 1) {
              return null;
            }
          }
          break;

        case "first":
        default:
          {
            if (glyphIndex != 0) {
              return null;
            }
          }
          break;
      }

      if (props.axis) {
        if (props.axis.visible) {
          var renderer = new axis_1.AxisRenderer();
          renderer.setAxisDataBinding(props.axis, 0, Math.sqrt((attrs.x2 - attrs.x1) * (attrs.x2 - attrs.x1) + (attrs.y2 - attrs.y1) * (attrs.y2 - attrs.y1)), false, false);
          var g = renderer.renderLine(0, 0, Math.atan2(attrs.y2 - attrs.y1, attrs.x2 - attrs.x1) / Math.PI * 180, -1);
          g.transform = cs.getLocalTransform(attrs.x1 + offset.x, attrs.y1 + offset.y);
          return g;
        } else {
          return null;
        }
      } else {
        var _renderer = new axis_1.AxisRenderer();

        _renderer.setAxisDataBinding(null, 0, Math.sqrt((attrs.x2 - attrs.x1) * (attrs.x2 - attrs.x1) + (attrs.y2 - attrs.y1) * (attrs.y2 - attrs.y1)), false, false);

        var _g = _renderer.renderLine(0, 0, Math.atan2(attrs.y2 - attrs.y1, attrs.x2 - attrs.x1) / Math.PI * 180, -1);

        _g.transform = cs.getLocalTransform(attrs.x1 + offset.x, attrs.y1 + offset.y);
        return _g;
      }
    }
  }, {
    key: "getSnappingGuides",
    value: function getSnappingGuides() {
      var attrs = this.state.attributes;
      var guides = [];

      if (attrs.x1 != attrs.x2) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = this.object.properties.dataExpressions[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var item = _step2.value;
            var attr = this.getAttributeNames(item)[0];
            guides.push({
              type: "x",
              value: attrs[attr],
              attribute: attr
            });
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }

      if (attrs.y1 != attrs.y2) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = this.object.properties.dataExpressions[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _item = _step3.value;
            var _attr = this.getAttributeNames(_item)[1];
            guides.push({
              type: "y",
              value: attrs[_attr],
              attribute: _attr
            });
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = this.object.properties.dataExpressions[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _item2 = _step4.value;

          var _this$getAttributeNam3 = this.getAttributeNames(_item2),
              _this$getAttributeNam4 = _slicedToArray(_this$getAttributeNam3, 2),
              attrX = _this$getAttributeNam4[0],
              attrY = _this$getAttributeNam4[1];

          guides.push({
            type: "label",
            x: attrs[attrX],
            y: attrs[attrY],
            text: _item2.expression
          });
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return guides;
    }
  }, {
    key: "getBoundingBox",
    value: function getBoundingBox() {
      var attrs = this.state.attributes;
      return {
        type: "line",
        x1: attrs.x1,
        y1: attrs.y1,
        x2: attrs.x2,
        y2: attrs.y2
      };
    } // Get DropZones given current state

  }, {
    key: "getDropZones",
    value: function getDropZones() {
      var attrs = this.state.attributes;
      var x1 = attrs.x1,
          y1 = attrs.y1,
          x2 = attrs.x2,
          y2 = attrs.y2;
      return [{
        type: "line",
        p1: {
          x: x1,
          y: y1
        },
        p2: {
          x: x2,
          y: y2
        },
        title: "Data Axis",
        dropAction: {
          axisInference: {
            property: "axis",
            appendToProperty: "dataExpressions"
          }
        }
      }];
    }
  }, {
    key: "getAttributePanelWidgets",
    value: function getAttributePanelWidgets(manager) {
      var _this = this;

      var props = this.object.properties;
      var axisWidgets = axis_1.buildAxisWidgets(props.axis, "axis", manager, "Data Axis");

      var r = _toConsumableArray(axisWidgets);

      r.push(manager.row("Visible On", manager.inputSelect({
        property: "visibleOn"
      }, {
        labels: ["All", "First", "Last"],
        showLabel: true,
        options: ["all", "first", "last"],
        type: "dropdown"
      })));

      if (props.dataExpressions.length > 0) {
        r.push(manager.sectionHeader("Data Expressions"));
        r.push(manager.arrayWidget({
          property: "dataExpressions"
        }, function (item) {
          return manager.inputExpression({
            property: "dataExpressions",
            field: item.field instanceof Array ? [].concat(_toConsumableArray(item.field), ["expression"]) : [item.field, "expression"]
          }, {
            table: _this.getGlyphClass().object.table
          });
        }, {
          allowDelete: true,
          allowReorder: true
        }));
      }

      return r;
    }
  }, {
    key: "getTemplateParameters",
    value: function getTemplateParameters() {
      var _this2 = this;

      var props = this.object.properties;
      var dataSource = {
        table: this.getGlyphClass().object.table,
        groupBy: null // TODO: fixme

      };

      if (props.dataExpressions && props.dataExpressions.length > 0) {
        return {
          inferences: [{
            objectID: this.object._id,
            dataSource: dataSource,
            axis: {
              expression: props.dataExpressions[0].expression,
              additionalExpressions: props.dataExpressions.map(function (x) {
                return x.expression;
              }),
              type: props.axis.type,
              property: "axis"
            }
          }].concat(_toConsumableArray(props.dataExpressions.map(function (x, i) {
            return {
              objectID: _this2.object._id,
              dataSource: dataSource,
              expression: {
                expression: x.expression,
                property: {
                  property: "dataExpressions",
                  field: [i, "expression"]
                }
              }
            };
          })))
        };
      }
    }
  }, {
    key: "attributeNames",
    get: function get() {
      var r = ["x1", "y1", "x2", "y2"];
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = this.object.properties.dataExpressions[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var item = _step5.value;

          var _this$getAttributeNam5 = this.getAttributeNames(item),
              _this$getAttributeNam6 = _slicedToArray(_this$getAttributeNam5, 2),
              xName = _this$getAttributeNam6[0],
              yName = _this$getAttributeNam6[1];

          r.push(xName);
          r.push(yName);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return r;
    }
  }, {
    key: "attributes",
    get: function get() {
      var r = Object.assign({}, attrs_1.AttrBuilder.line());
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = this.object.properties.dataExpressions[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var item = _step6.value;

          var _this$getAttributeNam7 = this.getAttributeNames(item),
              _this$getAttributeNam8 = _slicedToArray(_this$getAttributeNam7, 2),
              xName = _this$getAttributeNam8[0],
              yName = _this$getAttributeNam8[1];

          r[xName] = {
            name: xName,
            type: Specification.AttributeType.Number
          };
          r[yName] = {
            name: yName,
            type: Specification.AttributeType.Number
          };
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      return r;
    }
  }]);

  return DataAxisClass;
}(mark_1.MarkClass);

DataAxisClass.classID = "mark.data-axis";
DataAxisClass.type = "mark";
DataAxisClass.metadata = {
  displayName: "DataAxis",
  iconPath: "mark/data-axis",
  creatingInteraction: {
    type: "line-segment",
    mapping: {
      x1: "x1",
      y1: "y1",
      x2: "x2",
      y2: "y2"
    }
  }
};
DataAxisClass.defaultProperties = {
  dataExpressions: [],
  axis: null,
  visible: true,
  visibleOn: "first"
};
exports.DataAxisClass = DataAxisClass;